const API_BASE = process.env.REACT_APP_API_URL || '';

async function fetchApi(path) {
  const res = await fetch(`${API_BASE}/api${path}`);
  if (!res.ok) throw new Error(`API error: ${res.status}`);
  return res.json();
}

async function postApi(path, body) {
  const res = await fetch(`${API_BASE}/api${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || `API error: ${res.status}`);
  return data;
}

export function getCaseStudies() { return fetchApi('/case-studies'); }
export function getFeaturedCaseStudies() { return fetchApi('/case-studies/featured'); }
export function getCaseStudy(slug) { return fetchApi(`/case-studies/${slug}`); }
export function getBlogPosts(category) { return fetchApi(`/blog${category ? `?category=${category}` : ''}`); }
export function getBlogPost(slug) { return fetchApi(`/blog/${slug}`); }
export function getTestimonials() { return fetchApi('/testimonials'); }
export function getStats() { return fetchApi('/stats'); }
export function getTeam() { return fetchApi('/team'); }
export function getSettings() { return fetchApi('/settings'); }
export function submitContact(data) { return postApi('/contact', data); }
